import { get } from 'lodash/fp';
import axios from './axios';

export default (designId, leafItems, attributes, { cancellationKey, ...opts } = {}) =>
  axios.post('/jobs/by-design', {
    leafItems,
    extras: attributes || {},
  }, {
    params: {
      ...opts,
      designId,
    },
    cancellationKey: cancellationKey || designId,
  })
    .then(get('data'));
